import LegacyAccountModal from '@groovepages/gd-ui-kit/components/AccountModal';
import LegacyBaseLayout from '@groovepages/gd-ui-kit/components/BaseLayout';
import api from '@groovepages/gd-lib/api';
import Auth from '@groovepages/gd-lib/auth';
import Notify from '@groovepages/gd-lib/notify';
import axios from 'axios';
import keycloakAuth from '../services/keycloakAuth';
import getVideoId from 'get-video-id';
import { userRegion } from '@groovepages/gd-ui-kit/utils';
import { createCanonicalAccountModal, createCanonicalBaseLayout } from '../../../groove-ui-kit-v2/src/vue2/canonical-account';

const services = { api, Auth, Notify, axios, userRegion, getVideoId };
export const AccountModal = createCanonicalAccountModal(LegacyAccountModal, services);

const BaseLayout = createCanonicalBaseLayout({
  LegacyBaseLayout,
  AccountModal,
  services,
  name: 'DashboardAccountBaseLayout',
});

// Vue merges this method before evaluating the inherited account menu.
export default {
  ...BaseLayout,
  methods: {
    ...(BaseLayout.methods || {}),
    logout() {
      return keycloakAuth.logout({ clearAppSession: () => this.$store.commit('logout') });
    },
  },
};
